module.exports = __webpack_public_path__ + "img/avatar7.87072221.jpg";